import { useAuth } from '@forwardflow/context/AuthContext'
import { Avatar } from 'antd'

type AvatarType = {
    className?: string
    children?: React.ReactNode
    firstName?: string
    backgroundColor?: string
}

export const UserAvatar: React.FC<AvatarType> = ({
    className,
    children,
    firstName,
    backgroundColor = '#383838',
}) => {
    const {
        auth: { user },
    } = useAuth()

    const displayName = firstName || user?.firstName

    const getInitial = (name: string | undefined) => {
        return name ? name.charAt(0).toUpperCase() : ''
    }

    return (
        <Avatar
            className={`${className} text-[18px] md:text-[24px] w-9 h-9 md:w-[46px] md:h-[46px] font-medium`}
            style={{ backgroundColor }}
        >
            {children ? children : getInitial(displayName)}
        </Avatar>
    )
}
